/**
 * Time unit associated with the frequency of payments.
 * tag: 40754
 * @readonly
 * @enum {string} (String)
 */
export enum PaymentStreamPaymentFrequencyUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
  /** Term */
  Term = 'T',
}
